export default class extends Controller {
  static targets = ['title'];

  connect() {
    App.Helpers.listenToCustomEvent(document, 'brief-updated', this.replaceTitle.bind(this));
  }

  replaceTitle() {
    App.Helpers.ajaxRequest({
      url:            this.url,
      method:         'GET',
      successHandler: (res => this.title = res.title).bind(this)
    });
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url');
  }

  set title(val) {
    this.titleTarget.innerHTML = val;
  }
};



// WEBPACK FOOTER //
// ./app/components/headers/assets/javascript/brief-header-controller.js